import VueRouter from "vue-router";
import Vue from "vue";

Vue.use(VueRouter);
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";

//懒加载
const SendAnnouncement = () => import("@/pages/BasicSettings/SendAnnouncement");
const AboutUs = () => import("@/pages/BasicSettings/AboutUs");
const CareInstructions = () => import("@/pages/BasicSettings/CareInstructions");
const CareInstructionsContent = () =>
  import("@/pages/BasicSettings/CareInstructions/CareInstructionsContent");
const AddCareInstructions = () =>
  import("@/pages/BasicSettings/CareInstructions/AddCareInstructions");
const PlaceOrder = () => import("@/pages/BasicSettings/PlaceOrder");
const Coupon = () => import("@/pages/BasicSettings/Coupon");
const Carousel = () => import("@/pages/BasicSettings/Carousel");
const CollectionDiscount = () =>
  import("@/pages/BasicSettings/CollectionDiscount");
const PointsStore = () => import("@/pages/BasicSettings/PointsStore");
const PointsStoreContent = () =>
  import("@/pages/BasicSettings/PointsStore/PointsStoreContent");
const AddPointsStore = () =>
  import("@/pages/BasicSettings/PointsStore/AddPointsStore");

const WorkLog = () => import("@/pages/StoreInformation/WorkLog");
const StoreProductDetails = () =>
  import("@/pages/StoreInformation/StoreProductDetails");
const AddStoreProduct = () =>
  import("@/pages/StoreInformation/StoreProductDetails/AddStoreProduct");
const EditStoreProduct = () =>
  import("@/pages/StoreInformation/StoreProductDetails/EditStoreProduct");
const StoreOrderList = () => import("@/pages/StoreInformation/StoreOrderList");
const ProductCategory = () =>
  import("@/pages/StoreInformation/ProductCategory");

const StoreSettings = () => import("@/pages/StoreSettings");
const StoreInfoSetting = () => import("@/pages/StoreSettings/StoreInfoSetting");
const IncreasePermissions = () =>
  import("@/pages/StoreSettings/IncreasePermissions");
const AppraiserAccounts = () =>
  import("@/pages/StoreSettings/AppraiserAccounts");
const UserWallet = () => import("@/pages/StoreSettings/UserWallet");
const LoginInformation = () => import("@/pages/StoreSettings/LoginInformation");

const ChangePassword = () => import("@/pages/UserSettings/ChangePassword");

//静态加载
// import SendAnnouncement from "@/pages/BasicSettings/SendAnnouncement";
// import AboutUs from "@/pages/BasicSettings/AboutUs";
// import CareInstructions from "@/pages/BasicSettings/CareInstructions";
// import CareInstructionsContent from "@/pages/BasicSettings/CareInstructions/CareInstructionsContent";
// import AddCareInstructions from "@/pages/BasicSettings/CareInstructions/AddCareInstructions";
// import PlaceOrder from "@/pages/BasicSettings/PlaceOrder";
// import Coupon from "@/pages/BasicSettings/Coupon";
// import Carousel from "@/pages/BasicSettings/Carousel";
// import CollectionDiscount from "@/pages/BasicSettings/CollectionDiscount";
// import PointsStore from "@/pages/BasicSettings/PointsStore";
// import PointsStoreContent from "@/pages/BasicSettings/PointsStore/PointsStoreContent";
// import AddPointsStore from "@/pages/BasicSettings/PointsStore/AddPointsStore";

// import WorkLog from "@/pages/StoreInformation/WorkLog";
// import StoreProductDetails from "@/pages/StoreInformation/StoreProductDetails";
// import AddStoreProduct from "@/pages/StoreInformation/StoreProductDetails/AddStoreProduct";
// import EditStoreProduct from "@/pages/StoreInformation/StoreProductDetails/EditStoreProduct";
// import StoreOrderList from "@/pages/StoreInformation/StoreOrderList";

// import StoreSettings from "@/pages/StoreSettings";
// import StoreInfoSetting from "@/pages/StoreSettings/StoreInfoSetting";
// import IncreasePermissions from "@/pages/StoreSettings/IncreasePermissions";
// import LoginInformation from "@/pages/StoreSettings/LoginInformation";
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;

// 重写push和replace方法，解决重复点击报错问题
VueRouter.prototype.push = function (location, onResolved, onRejected) {
  if (onResolved === undefined && onRejected === undefined) {
    originPush.call(this, location).catch(() => {});
  } else {
    originPush.call(this, location, onResolved, onRejected);
  }
};
VueRouter.prototype.replace = function (location, onResolved, onRejected) {
  if (onResolved === undefined && onRejected === undefined) {
    originReplace.call(this, location).catch(() => {});
  } else {
    originPush.call(this, location, onResolved, onRejected);
  }
};

export default new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "/Overview",
    },
    {
      name: "Login",
      path: "/Login",
      component: Login,
      meta: {
        title: "登录",
        needLogin: false,
      },
    },
    {
      name: "Overview",
      path: "/Overview",
      component: Overview,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "SendAnnouncement",
      path: "/BasicSettings/SendAnnouncement",
      component: SendAnnouncement,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "AboutUs",
      path: "/BasicSettings/AboutUs",
      component: AboutUs,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "CareInstructions",
      path: "/BasicSettings/CareInstructions",
      component: CareInstructions,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "CareInstructionsContent",
      path: "/BasicSettings/CareInstructions/CareInstructionsContent",
      component: CareInstructionsContent,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "AddCareInstructions",
      path: "/BasicSettings/CareInstructions/AddCareInstructions",
      component: AddCareInstructions,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "PlaceOrder",
      path: "/BasicSettings/PlaceOrder",
      component: PlaceOrder,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "Coupon",
      path: "/BasicSettings/Coupon",
      component: Coupon,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "Carousel",
      path: "/BasicSettings/Carousel",
      component: Carousel,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "CollectionDiscount",
      path: "/BasicSettings/CollectionDiscount",
      component: CollectionDiscount,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "PointsStore",
      path: "/BasicSettings/PointsStore",
      component: PointsStore,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "PointsStoreContent",
      path: "/BasicSettings/PointsStore/PointsStoreContent",
      component: PointsStoreContent,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "AddPointsStore",
      path: "/BasicSettings/PointsStore/AddPointsStore",
      component: AddPointsStore,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "WorkLog",
      path: "/StoreInformation/WorkLog",
      component: WorkLog,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "StoreOrderList",
      path: "/StoreInformation/StoreOrderList",
      component: StoreOrderList,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "ProductCategory",
      path: "/StoreInformation/ProductCategory",
      component: ProductCategory,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "StoreProductDetails",
      path: "/StoreInformation/StoreProductDetails",
      component: StoreProductDetails,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "AddStoreProduct",
      path: "/StoreInformation/StoreProductDetails/AddStoreProduct",
      component: AddStoreProduct,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "EditStoreProduct",
      path: "/StoreInformation/StoreProductDetails/EditStoreProduct",
      component: EditStoreProduct,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "StoreSettings",
      path: "/StoreSettings",
      component: StoreSettings,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "StoreInfoSetting",
      path: "/StoreSettings/StoreInfoSetting",
      component: StoreInfoSetting,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "LoginInformation",
      path: "/StoreSettings/LoginInformation",
      component: LoginInformation,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "IncreasePermissions",
      path: "/StoreSettings/IncreasePermissions",
      component: IncreasePermissions,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "AppraiserAccounts",
      path: "/StoreSettings/AppraiserAccounts",
      component: AppraiserAccounts,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "UserWallet",
      path: "/StoreSettings/UserWallet",
      component: UserWallet,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "UserSettings",
      path: "/UserSettings/ChangePassword",
      component: ChangePassword,
      meta: {
        needLogin: true,
      },
    },
    {
      name: "FriendshipLink",
      path: "/FriendshipLink",
      meta: {
        needLogin: true,
      },
    },
  ],
});
